'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcCanvas
* @element ANY
* @description
* # tcCanvas
* Allows HTML5 canvas editing
*/
angular.module('tcApp').directive('tcCanvas', function($parse) {
	return {
		restrict: 'A',
		scope: true,
		link: function(scope, element, attrs) {
			var dataItem = scope.data.items[attrs.tcDataItem];
			if (angular.isUndefined(dataItem)) return;
			
			var isDisabled = $parse(dataItem.disabled)(scope);
			var isReadOnly = $parse(dataItem.readOnly)(scope);
			var canvasContext = element[0].getContext('2d');
			/* This kind of thing doesn't work.. just using static height/width on all sizes
			if ($mdMedia('sm')) {
				element[0].setAttribute('width', 225);
				element[0].setAttribute('height', 150);
				canvasContext.scale(0.75,0.75);
			}
			*/
			// variable that decides if something should be drawn on mousemove
			var drawing = false;
      
			var currentX = 0;
			var currentY = 0;

			// the last coordinates before the current move
			var lastX;
			var lastY;
			
			// Load image from component data item
			// May need to de-couple from component later on
			if ((dataItem.value !== '') && (!isDisabled)) {
				var img = new Image(); //eslint-disable-line
				img.onload = function() { 
					canvasContext.drawImage(img, 0, 0);
				};
				img.src = dataItem.value;
			}
			
			var startDrawing = function(event) {
				if (isDisabled || isReadOnly) return;
				event.preventDefault();
				var canvasPosition = element[0].getBoundingClientRect();
				
				if (angular.isDefined(event.offsetX)) {
					lastX = event.offsetX;
					lastY = event.offsetY;
				} else if (event.type === 'touchstart') {
					lastX = event.touches[0].pageX - canvasPosition.left;
					lastY = event.touches[0].pageY - canvasPosition.top;
				} else {
					lastX = event.layerX - event.currentTarget.offsetLeft;
					lastY = event.layerY - event.currentTarget.offsetTop;
				}
				
				// begins new line
				canvasContext.beginPath();
        
				drawing = true;
			};
			
			var continueDrawing = function(event) {
				if (isDisabled || isReadOnly) return;

				if (drawing) {
					event.preventDefault();
					if ((event.type === 'mousemove') && (event.which === 0)) {
						stopDrawing();
						return;
					}
					
					var canvasPosition = element[0].getBoundingClientRect();
					
					// get current mouse position
					if (angular.isDefined(event.offsetX)) {
						currentX = event.offsetX;
						currentY = event.offsetY;
					} else if (event.type === 'touchmove') {
						currentX = event.touches[0].pageX - canvasPosition.left;
						currentY = event.touches[0].pageY - canvasPosition.top;
					} else {
						currentX = event.layerX - event.currentTarget.offsetLeft;
						currentY = event.layerY - event.currentTarget.offsetTop;
					}
					draw(lastX, lastY, currentX, currentY);
          
					// set current coordinates to last one
					lastX = currentX;
					lastY = currentY;
				}
			};
			
			var stopDrawing = function() {
				if (isDisabled || isReadOnly) return;
				
				// stop drawing
				drawing = false;
				
				// Save the value into the component data object
				dataItem.value = element[0].toDataURL('image/png');
				if (dataItem.value !== dataItem.defaultValue) {
					if ((scope.componentForm) && scope.componentForm[scope.componentHtmlName]) {
						scope.componentForm[scope.componentHtmlName].$setDirty();
					}
				}
			};
			
			// Bind all mouse & touch events
			element.bind('mousedown', startDrawing);
			element.bind('mousemove', continueDrawing);
			element.bind('mouseup', stopDrawing);
			element.bind('touchstart', startDrawing);
			element.bind('touchmove', continueDrawing);
			element.bind('touchend', stopDrawing);

			// canvas reset
			var clearCanvas = function() {
				dataItem.value = '';
			};
			
			scope.$on('Canvas:Clear', function($event, itemName) {
				if (itemName !== attrs.tcDataItem) return;
				clearCanvas();
			});

			function draw(lX, lY, cX, cY) {
				// line from
				canvasContext.moveTo(lX, lY);
				// to
				canvasContext.lineTo(cX, cY);
				// color
				canvasContext.strokeStyle = '#4b4b4b';
				// draw it
				canvasContext.stroke();
			}
		}
	};
});
